import React from "react";
import { PropertyValuationData } from "../types/valuation";
import { TenantConfig } from "../types/tenant";
import { pdf } from "@react-pdf/renderer";
import PropertyReport from "../components/reports/PropertyReport";

interface ReportConfig {
  colors: {
    primary: string;
    text: string;
  };
  tenant: TenantConfig;
}

export const generatePropertyReport = async (
  propertyData: PropertyValuationData,
  config: ReportConfig
) => {
  try {
    // Generate PDF without photos
    const element = React.createElement(PropertyReport, {
      propertyData,
      tenant: config.tenant,
    });

    const blob = await pdf(element as unknown as React.ReactElement).toBlob();

    // Create download URL
    const url = URL.createObjectURL(blob);

    // Create temporary link and trigger download
    const link = document.createElement("a");
    link.href = url;
    const fileName =
      propertyData.propertyInfo?.address?.address?.split(",")[0] || "property";
    link.download = `${fileName
      .replace(/[^a-z0-9]/gi, "-")
      .toLowerCase()}-report.pdf`;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};
